export var headingTarget = '_1QCI7';
export var videoEmbedTarget = '_2Er4z';